export function appendString (classList, classToAppend) {
  if (classList && classList.length > 0) {
    classList = `${classList} ${classToAppend}`;
  } else {
    classList = classToAppend;
  }

  return classList;
}
